<template>
  <div>
    <enable-disable-reply
      v-model="enabled"
      keyword="story-private-reply"
      @fetched="fetched=$event"
    />
    <bot-reply-form
      v-if="fetched && enabled"
      keyword="story-private-reply"
    />
  </div>
</template>

<script>

import BotReplyForm from '@/views/owner-instagram/bot/BotReplyForm'
import EnableDisableReply from '@/views/owner-instagram/bot/EnableDisableReply'

export default {
  name: 'StoryCommentReply',
  components: { EnableDisableReply, BotReplyForm },
  data() {
    return {
      enabled: false,
      fetched: false,
    }
  },
  mounted() {
    this.$store.commit('bot/SET_DEFAULT_FORM')
  },
}
</script>
